(function($) {
  'use strict';

  $(document).ready(() => {
    var search = location?.search?.substring(1);
    if(search) {
      const params = JSON.parse('{"' + search.replace(/&/g, '","').replace(/=/g, '":"') + '"}', function (key, value) {
        return key === "" ? value : decodeURIComponent(value)
      })
      if (params?.form === 'counsel') {
        $('.overlay_wrapper.counsel').addClass('open');
      }
      else if (params?.form === 'register') {
        $('.overlay_wrapper.register').addClass('open');
      }
    }
  })

  $('.toggleOverlay').on("click", function() {
    const e = $(this);
    if (e.hasClass('counsel')) {
      var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?form=counsel';
      window.history.pushState({path:newurl},'',newurl);
      $('.overlay_wrapper.counsel').addClass('open');
    } else if (e.hasClass('register')) {
      var newurl2 = window.location.protocol + "//" + window.location.host + window.location.pathname + '?form=register';
      window.history.pushState({path:newurl2},'',newurl2);
      $('.overlay_wrapper.register').addClass('open');
    } else {
      e.siblings('.overlay_wrapper').addClass('open');
    }

    $('body').addClass('no-scroll');
  });

  $('.overlay_wrapper').on("click", (e) => {
    if ($(e.target).hasClass('open')) {
      var newurl2 = window.location.href.replace(/form=([^&#]*)/, '');
      window.history.pushState({path:newurl2},'',newurl2);
      $(e.target).removeClass('open');
      $('body').removeClass('no-scroll');
    }
  });

  $('.overlay_close').on("click", (e) => {
    var newurl2 = window.location.href.replace(/form=([^&#]*)/, '');
    window.history.pushState({path:newurl2},'',newurl2);
    $('.overlay_wrapper').removeClass('open');
    $('body').removeClass('no-scroll');
  });

})(jQuery);
